import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

export const ChangePillarConfirmationDialog = ({
  isOpen,
  close,
  onConfirm,
  dynamicProps,
  isLoading,
}: {
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close: (dynamicProps?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onConfirm: (dynamicProps?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dynamicProps?: any;
  isLoading?: boolean;
}) => (
  <Modal
    isVisible={isOpen}
    close={() => close(dynamicProps)}
    className="max-w-[624px]"
  >
    <div className="flex flex-col gap-2 rounded-t-lg bg-background-base-surface-2">
      <h1 className="bg-background-base-surface-3 px-8 py-6  text-[28px] leading-9 text-content-base-default">
        Unsaved changes
      </h1>
      <div className="space-y-12 p-8">
        <div>
          <p className="font-bold text-content-base-subdued">
            There are unsaved changes to your notification preferences for the
            current workspace. Do you want to save your changes before leaving
            the page, or discard them?
          </p>
        </div>
        <div className="flex gap-5">
          <GraniteButton
            size="large"
            variant="secondary"
            onClick={() => close(dynamicProps)}
          >
            Discard changes
          </GraniteButton>
          <GraniteButton
            size="large"
            variant="primary"
            onClick={() => {
              onConfirm(dynamicProps);
            }}
            disabled={isLoading}
          >
            Save changes
          </GraniteButton>
        </div>
      </div>
    </div>
  </Modal>
);
